var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5358 0C11.1639 0 14.115 2.95111 14.115 6.57919C14.115 8.2909 13.4581 9.85208 12.3831 11.0238L14.4983 13.1345C14.6963 13.3325 14.697 13.6527 14.499 13.8507C14.4004 13.9507 14.27 14 14.1403 14C14.0112 14 13.8815 13.9507 13.7822 13.852L11.6414 11.7173C10.5153 12.6191 9.08748 13.1591 7.5358 13.1591C3.90772 13.1591 0.955933 10.2073 0.955933 6.57919C0.955933 2.95111 3.90772 0 7.5358 0ZM7.5358 1.01343C4.46646 1.01343 1.96936 3.50985 1.96936 6.57919C1.96936 9.64853 4.46646 12.1456 7.5358 12.1456C10.6045 12.1456 13.1016 9.64853 13.1016 6.57919C13.1016 3.50985 10.6045 1.01343 7.5358 1.01343Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.4ec1e6f724bc244e6af507ba24ff9c9b.svg";
export { ForwardRef as ReactComponent };